import BannerVideo from '../video/BannerVideo';
import './modal.scss';

const VideoModalWindow = ({ onClose }) => {
  return (
    <div className="video-container">
      <button
        type="button"
        className="modal-close"
        onClick={onClose}
        title="Close"
      />

      <BannerVideo />
    </div>
  );
};

export default VideoModalWindow;
